import { forwardRef } from 'react';
import clsx from 'clsx';

import type { LinksFunction } from '@remix-run/node';
import type { DbooInputProps } from './dboo-input.types';

import { SharedIcon } from '@/components/shared/shared-icon/shared-icon';

import styles from './dboo-input.css?url';

export const links: LinksFunction = () => {
  return [{ rel: 'stylesheet', href: styles }];
};

export const DbooInput = forwardRef<HTMLInputElement, DbooInputProps>(
  ({ className = '', error, theme = 'light', prefix, ...props }, ref) => {
    const inputClassNames = clsx('dboo-input', className, {
      'dboo-input--light': theme === 'light',
      'dboo-input--dark': theme === 'dark',
    });

    return (
      <div className={inputClassNames}>
        <label
          className="dboo-input__inner dboo-field--bordered-gradient"
          data-placeholder={props.placeholder}
        >
          {prefix && <div className="dboo-input__prefix">{prefix}</div>}
          <input
            className={clsx('dboo-input__field', {
              'dboo-input__field--error': !!error,
              'dboo-input__field--prefixed': !!prefix,
            })}
            {...props}
            id={props.name}
            ref={ref}
          />
        </label>

        {error && (
          <div className="dboo-input__error" aria-live="assertive">
            <SharedIcon
              className="dboo-input__error-icon"
              name="exclamation-circle-empty"
            />
            <p>{error}</p>
          </div>
        )}
      </div>
    );
  },
);

DbooInput.displayName = 'DbooInput';
